import ModalCadastro from "../../../../components/ModalCadastro/ModalCadastro.tsx";
import ModalConfigTabela from "../../../../components/ModalConfigTabela/ModalConfigTabela.tsx";
import ModalConfirmacao from "../../../../components/ModalConfirmacao/ModalConfirmacao.tsx";
import ModalConfirmacao2 from "../../../../components/ModalConfirmacao2/ModalConfirmacao2.tsx";
import ModalEditarDatas from "../../../../components/ModalEditarDatas/ModalEditarDatas.tsx";
import ModalEmbarque from "../../../../components/ModalEmbarque/ModalEmbarque.tsx";
import ModalHistoricoEdicao from "../../../../components/ModalHistoricoEdicao/ModalHistoricoEdicao.tsx";
import ModalHistoricoStatus from "../../../../components/ModalHistoricoStatus/ModalHistoricoStatus.tsx";
import ModalLancarCTE from "../../../../components/ModalLancarCTE/ModalLancarCTE.tsx";
import ModalLancarEmbalagem from "../../../../components/ModalLancarEmbalagem/ModalLancarEmbalagem.tsx";
import ModalLancarMeioPagamento from "../../../../components/ModalLancarMeioPagamento/ModalLancarMeioPagamento.tsx";
import ModalLancarMercadoria from "../../../../components/ModalLancarMercadoria/ModalLancarMercadoria.tsx";
import ModalLancarStatus from "../../../../components/ModalLancarStatus/ModalLancarStatus.tsx";
import ModalLancarVeiculo from "../../../../components/ModalLancarVeiculo/ModalLancarVeiculo.tsx";
import ModalLegenda from "../../../../components/ModalLegenda/ModalLegenda.tsx";
import ModalListaErros from "../../../../components/ModalListaErros/ModalListaErros.tsx";
import ModalOnTime from "../../../../components/ModalOnTime/ModalOnTime.tsx";
import ModalStatusSMP from "../../../../components/ModalStatusSMP/ModalStatusSMP.tsx";
import ModalUsuario from "../../../../components/ModalUsuario/ModalUsuario.tsx";

interface ModaisEmbarqueProps {
    openCadastroPedido: boolean;
    handleCloseCadastroPedido: () => void;
    openCadastroUnidadeEmbarque: boolean;
    handleCloseCadastroUnidadeEmbarque: () => void;
    openCadastroFilial: boolean;
    handleCloseCadastroFilial: () => void;
    openCadastroEmpresa: boolean;
    handleCloseCadastroEmpresa: () => void;
    openCadastroVeiculo: boolean;
    handleCloseCadastroVeiculo: () => void;
    openCadastroMercadoria: boolean;
    handleCloseCadastroMercadoria: () => void;
    openCadastroEmbalagem: boolean;
    handleCloseCadastroEmbalagem: () => void;
    openCadastroStatus: boolean;
    handleCloseCadastroStatus: () => void;
    openCadastroMotivo: boolean;
    handleCloseCadastroMotivo: () => void;
    openCadastroMeioPagamento: boolean;
    handleCloseCadastroMeioPagamento: () => void;
    open: boolean;
    handleClose: () => void;
    deletarEmbarquePorId: () => void;
    openConfirmar: boolean;
    handleCloseConfirmar: () => void;
    inserirSMP: () => void;
    openModalInformacoes: boolean;
    handleCloseModalInformacoes: () => void;
    statusSMP: any;
    openListaErro: boolean;
    handleCloseListaErro: () => void;
    mensagensAviso: { codigo: number; mensagem: string; }[];
    mensagensErro: { codigo: number; mensagem: string; }[];
    mensagensSucesso: { codigo: number; mensagem: string; }[];
    openUsuario: boolean;
    handleCloseUsuario: () => void;
    openLegenda: boolean;
    handleCloseLegenda: () => void;
    openHistoricoStatus: boolean;
    handleCloseHistoricoStatus: () => void;
    valoresHistoricoStatus: any[];
    colunasStatusEmbarque: any[];
    openHistoricoPedido: boolean;
    handleCloseHistoricoPedido: () => void;
    valoresHistoricoPedido: any[];
    colunasPedidoEmbarque: any[];
    openHistoricoFreteFiscal: boolean;
    handleCloseHistoricoFreteFiscal: () => void;
    valoresHistoricoFreteFiscal: any[];
    colunasFreteFiscalEmbarque: any[];
    tabelaRedux: any;
    valoresHistorico: any[];
    values: any;
    openHistoricoEdicao: boolean;
    handleCloseHistoricoEdicao: () => void;
    openProposta: boolean;
    handleCloseProposta: () => void;
    enviaProposta: () => void;
    setGrupoCargaId: (id: string) => void;
    setMotoristasId: (id: string) => void;
    setProprietariosId: (id: string) => void;
    openMotivoOnTime: boolean;
    handleCloseMotivoOnTime: () => void;
    vincularMotivoOnTime: () => void;
    setMotivoId: (id: string) => void;
    setNomeMotivo: (nome: string) => void;
    openMotivoCancelado: boolean;
    handleCloseMotivoCancelado: () => void;
    cancelarCarga: () => void;
    setMotivoId2: (id: string) => void;
    openCTE: boolean;
    handleCloseCTE: () => void;
    onSuccessDefinirCte: () => void;
    onErrorDefinirCte: () => void;
    openStatus: boolean;
    handleCloseStatus: () => void;
    definirStatus: () => void;
    setStatus: (status: string) => void;
    openEmbalagem: boolean;
    handleCloseEmbalagem: () => void;
    definirEmbalagem: () => void;
    setEmbalagem: (embalagem: string) => void;
    openMercadoria: boolean;
    handleCloseMercadoria: () => void;
    definirMercadoria: () => void;
    setMercadoria: (mercadoria: string) => void;
    openVeiculo: boolean;
    handleCloseVeiculo: () => void;
    definirVeiculo: () => void;
    setVeiculo: (veiculo: string) => void;
    setMotorista: (motorista: string) => void;
    openMeioPagamento: boolean;
    handleCloseMeioPagamento: () => void;
    definirMeioPagameto: () => void;
    setMeioPagamento1: (meio: string) => void;
    setMeioPagamento2: (meio: string) => void;
    openAlterarDatas: boolean;
    setOpenAlterarDatas: (open: boolean) => void;
    handleOnSuccessEditarDatas: () => void;
    odenConfig: boolean;
    handleCloseConfig: () => void;
    contextoEmbarque: string;
    tabelaUsuario: any;
    openEmbarque: boolean;
    handleCloseEmbarque: () => void;
}

function ModaisEmbarque({
    openCadastroPedido,
    handleCloseCadastroPedido,
    openCadastroUnidadeEmbarque,
    handleCloseCadastroUnidadeEmbarque,
    openCadastroFilial,
    handleCloseCadastroFilial,
    openCadastroEmpresa,
    handleCloseCadastroEmpresa,
    openCadastroVeiculo,
    handleCloseCadastroVeiculo,
    openCadastroMercadoria,
    handleCloseCadastroMercadoria,
    openCadastroEmbalagem,
    handleCloseCadastroEmbalagem,
    openCadastroStatus,
    handleCloseCadastroStatus,
    openCadastroMotivo,
    handleCloseCadastroMotivo,
    openCadastroMeioPagamento,
    handleCloseCadastroMeioPagamento,
    open,
    handleClose,
    deletarEmbarquePorId,
    openConfirmar,
    handleCloseConfirmar,
    inserirSMP,
    openModalInformacoes,
    handleCloseModalInformacoes,
    statusSMP,
    openListaErro,
    handleCloseListaErro,
    mensagensAviso,
    mensagensErro,
    mensagensSucesso,
    openUsuario,
    handleCloseUsuario,
    openLegenda,
    handleCloseLegenda,
    openHistoricoStatus,
    handleCloseHistoricoStatus,
    valoresHistoricoStatus,
    colunasStatusEmbarque,
    openHistoricoPedido,
    handleCloseHistoricoPedido,
    valoresHistoricoPedido,
    colunasPedidoEmbarque,
    openHistoricoFreteFiscal,
    handleCloseHistoricoFreteFiscal,
    valoresHistoricoFreteFiscal,
    colunasFreteFiscalEmbarque,
    tabelaRedux,
    valoresHistorico,
    values,
    openHistoricoEdicao,
    handleCloseHistoricoEdicao,
    openProposta,
    handleCloseProposta,
    enviaProposta,
    setGrupoCargaId,
    setMotoristasId,
    setProprietariosId,
    openMotivoOnTime,
    handleCloseMotivoOnTime,
    vincularMotivoOnTime,
    setMotivoId,
    setNomeMotivo,
    openMotivoCancelado,
    handleCloseMotivoCancelado,
    cancelarCarga,
    setMotivoId2,
    openCTE,
    handleCloseCTE,
    onSuccessDefinirCte,
    onErrorDefinirCte,
    openStatus,
    handleCloseStatus,
    definirStatus,
    setStatus,
    openEmbalagem,
    handleCloseEmbalagem,
    definirEmbalagem,
    setEmbalagem,
    openMercadoria,
    handleCloseMercadoria,
    definirMercadoria,
    setMercadoria,
    openVeiculo,
    handleCloseVeiculo,
    definirVeiculo,
    setVeiculo,
    setMotorista,
    openMeioPagamento,
    handleCloseMeioPagamento,
    definirMeioPagameto,
    setMeioPagamento1,
    setMeioPagamento2,
    openAlterarDatas,
    setOpenAlterarDatas,
    handleOnSuccessEditarDatas,
    odenConfig,
    handleCloseConfig,
    contextoEmbarque,
    tabelaUsuario,
    openEmbarque,
    handleCloseEmbarque,
}: ModaisEmbarqueProps) {
    return (
        <>
            <ModalCadastro
                titulo="Cadastro"
                tituloConfirmar="OK"
                cadastroPedido="sim"
                open={openCadastroPedido}
                onClose={handleCloseCadastroPedido}
            />
            <ModalCadastro
                titulo="Cadastro"
                tituloConfirmar="OK"
                cadastroUnidadeEmbarque="sim"
                open={openCadastroUnidadeEmbarque}
                onClose={handleCloseCadastroUnidadeEmbarque}
            />
            <ModalCadastro
                titulo="Cadastro"
                tituloConfirmar="OK"
                cadastroFilial="sim"
                open={openCadastroFilial}
                onClose={handleCloseCadastroFilial}
            />
            <ModalCadastro
                titulo="Cadastro"
                tituloConfirmar="OK"
                cadastroEmpresaSub="sim"
                open={openCadastroEmpresa}
                onClose={handleCloseCadastroEmpresa}
            />
            <ModalCadastro
                titulo="Cadastro"
                tituloConfirmar="OK"
                cadastroVeiculo="sim"
                open={openCadastroVeiculo}
                onClose={handleCloseCadastroVeiculo}
            />
            <ModalCadastro
                titulo="Cadastro"
                tituloConfirmar="OK"
                cadastroMercadoria="sim"
                open={openCadastroMercadoria}
                onClose={handleCloseCadastroMercadoria}
            />
            <ModalCadastro
                titulo="Cadastro"
                tituloConfirmar="OK"
                cadastroEmbalagem="sim"
                open={openCadastroEmbalagem}
                onClose={handleCloseCadastroEmbalagem}
            />
            <ModalCadastro
                titulo="Cadastro"
                tituloConfirmar="OK"
                cadastroStatus="sim"
                open={openCadastroStatus}
                onClose={handleCloseCadastroStatus}
            />
            <ModalCadastro
                titulo="Cadastro"
                tituloConfirmar="OK"
                cadastroMotivo="sim"
                open={openCadastroMotivo}
                onClose={handleCloseCadastroMotivo}
            />
            <ModalCadastro
                titulo="Cadastro"
                tituloConfirmar="OK"
                cadastroMeioPagamento="sim"
                open={openCadastroMeioPagamento}
                onClose={handleCloseCadastroMeioPagamento}
            />
            <ModalConfirmacao
                titulo="Deletar"
                texto="Deseja Deletar?"
                open={open}
                onClose={handleClose}
                onClick={deletarEmbarquePorId}
            />
            <ModalConfirmacao2
                titulo="SMP"
                texto="Deseja Inserir SMP?"
                textoBotao="Sim"
                open={openConfirmar}
                onClose={handleCloseConfirmar}
                onClick={inserirSMP}
            />
            <ModalStatusSMP
                titulo="Status do SMP"
                textoBotao="OK"
                onClose={handleCloseModalInformacoes}
                onClick={handleCloseModalInformacoes}
                open={openModalInformacoes}
                texto=""
                statusSMP={statusSMP}
            />
            <ModalListaErros
                titulo="Listagem Sucessos/Aviso/Erros"
                texto="Foram retornadas as seguintes ocorrências na tentaviva de inserir o SMP."
                textoBotao="Ok"
                open={openListaErro}
                onClose={handleCloseListaErro}
                onClick={handleCloseListaErro}
                mensagensAviso={mensagensAviso}
                mensagensErro={mensagensErro}
                mensagensSucesso={mensagensSucesso}
            />
            <ModalUsuario
                titulo="Usuário"
                tituloConfirmar="OK"
                open={openUsuario}
                onClose={handleCloseUsuario}
            />
            <ModalLegenda
                titulo="Legendas"
                open={openLegenda}
                onClose={handleCloseLegenda}
            />
            <ModalHistoricoStatus
                titulo="Histórico Status"
                tituloConfirmar="OK"
                open={openHistoricoStatus}
                onClose={handleCloseHistoricoStatus}
                valoresHistorico={valoresHistoricoStatus}
                colunas={colunasStatusEmbarque}
            />
            <ModalHistoricoStatus
                titulo="Histórico Pedido"
                tituloConfirmar="OK"
                open={openHistoricoPedido}
                onClose={handleCloseHistoricoPedido}
                valoresHistorico={valoresHistoricoPedido}
                colunas={colunasPedidoEmbarque}
            />
            <ModalHistoricoStatus
                titulo="Histórico Frete Fiscal"
                tituloConfirmar="OK"
                open={openHistoricoFreteFiscal}
                onClose={handleCloseHistoricoFreteFiscal}
                valoresHistorico={valoresHistoricoFreteFiscal}
                colunas={colunasFreteFiscalEmbarque}
            />
            <ModalHistoricoEdicao
                valueTabela={tabelaRedux}
                valueDados={valoresHistorico}
                open={openHistoricoEdicao}
                onClose={handleCloseHistoricoEdicao}
                titulo="Histórico"
                classeSelecionado="idEmbarque"
                colunas="Embarque"
                nome="embarque"
            />
            <ModalOnTime
                titulo="Vincular Motivo"
                open={openMotivoOnTime}
                onClose={handleCloseMotivoOnTime}
                onClick={vincularMotivoOnTime}
                setMotivoId={setMotivoId}
                setNomeMotivo={setNomeMotivo}
                tituloBotao=""
                texto=""
            />
            <ModalOnTime
                titulo="Motivo Cancelamento"
                open={openMotivoCancelado}
                onClose={handleCloseMotivoCancelado}
                onClick={cancelarCarga}
                setMotivoId={setMotivoId2}
                setNomeMotivo={setNomeMotivo}
                tituloBotao=""
                texto=""
            />
            <ModalLancarCTE
                titulo="Lançar CTE"
                tituloConfirmar="OK"
                open={openCTE}
                onClose={handleCloseCTE}
                onSuccess={onSuccessDefinirCte}
                onError={onErrorDefinirCte}
                tituloBotao=""
                texto=""
                dataAlteracao=""
                onClick={()=>{}}
            />
            <ModalLancarStatus
                titulo="Lançar Status"
                tituloConfirmar="OK"
                open={openStatus}
                onClick={definirStatus}
                onClose={handleCloseStatus}
                setStatus={setStatus}
                tituloBotao=""
                texto=""
                dataAlteracao=""
            />
            <ModalLancarEmbalagem
                titulo="Lançar Embalagem"
                tituloConfirmar="OK"
                open={openEmbalagem}
                onClick={definirEmbalagem}
                onClose={handleCloseEmbalagem}
                setEmbalagem={setEmbalagem}
                tituloBotao=""
                texto=""
                dataAlteracao=""
            />
            <ModalLancarMercadoria
                titulo="Lançar Mercadoria"
                tituloConfirmar="OK"
                open={openMercadoria}
                onClick={definirMercadoria}
                onClose={handleCloseMercadoria}
                setMercadoria={setMercadoria}
                tituloBotao=""
                texto=""
                dataAlteracao=""
            />
            <ModalLancarVeiculo
                titulo="Lançar Veículo"
                tituloConfirmar="OK"
                open={openVeiculo}
                onClick={definirVeiculo}
                onClose={handleCloseVeiculo}
                setVeiculo={setVeiculo}
                setMotorista={setMotorista}
                tituloBotao=""
                texto=""
                dataAlteracao=""
            />
            <ModalLancarMeioPagamento
                titulo="Definir Meios de Pagameto"
                tituloConfirmar="OK"
                open={openMeioPagamento}
                onClick={definirMeioPagameto}
                onClose={handleCloseMeioPagamento}
                setMeioPagamento1={setMeioPagamento1}
                setMeioPagamento2={setMeioPagamento2}
                tituloBotao=""
                texto=""
                dataAlteracao=""
            />
            <ModalEditarDatas
                open={openAlterarDatas}
                onClose={() => setOpenAlterarDatas(false)}
                onSuccess={handleOnSuccessEditarDatas}
            />
            <ModalConfigTabela
                titulo="Colunas Visíveis"
                tituloConfirmar="OK"
                open={odenConfig}
                onClose={handleCloseConfig}
                checks={
                    contextoEmbarque !== "templateEmbarque"
                        ? tabelaUsuario?.Embarque
                        : tabelaUsuario?.ModeloEmbarque
                }
                nome={contextoEmbarque !== "templateEmbarque" ? "embarque" : "modelo"}
            />
            <ModalEmbarque open={openEmbarque} onClose={handleCloseEmbarque} onClick={()=>{}} />
        </>
    )
};

export default ModaisEmbarque;